// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"icon-wrapper_3pYdm","tips":"tips_3VqDa","show":"show_YTB1a"};